import { Alert, Paper } from "@mui/material";

export const NoDataAlert = ({ message }) => (
  <Paper sx={{ p: 3, boxShadow: "none" }}>
    <Alert
      sx={{
        borderRadius: "0.5rem",
        border: 1,
        fontWeight: 600,
        color: "info.dark",
      }}
      severity="info"
    >
      {message}
    </Alert>
  </Paper>
);
